var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentationMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6093 9.33333L18.6667 0.390667C18.4147 0.138667 18.08 0 17.724 0H5.33333C4.598 0 4 0.598 4 1.33333V30.6667C4 31.402 4.598 32 5.33333 32H26.6667C27.402 32 28 31.402 28 30.6667V10.276C28 9.92533 27.858 9.58133 27.6093 9.33333ZM18.6667 2.276L25.724 9.33333H18.6667V2.276ZM5.33333 30.6667V1.33333H17.3333V10C17.3333 10.3687 17.632 10.6667 18 10.6667H26.6667L26.6673 30.6667H5.33333Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 14.6667H9.33333V16H22.6667V14.6667Z",
    fill: "#B4B4B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 20H9.33333V21.3333H22.6667V20Z",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 25.3333H9.33333V26.6667H18.6667V25.3333Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentationMenuIcon);
export default __webpack_public_path__ + "static/media/documentation_menu_icon.72ee666bdf2aaee14176f7b76e8b304d.svg";
export { ForwardRef as ReactComponent };